import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { Box, Grid } from '@mui/material';
import { toLocalePrice } from '@siren-frontend/shared';
import { isEmpty } from 'lodash-es';
import PropTypes from 'prop-types';

import CompetitorSwitcher from './CompetitorSwitcher';
import ContactUsBox from './ContactUsBox';

function CalculatorInstancePricing({
  calculatorInputs,
  calculatedCluster,
  setMode,
  error,
}) {
  if (isEmpty(calculatedCluster.cluster)) {
    const text = error
      ? 'There was an error while fetching calculator data. Try again later.'
      : 'No Scylla cluster matches given inputs';

    return (
      <Box className="flex-container direction-column aligned-center">
        <Box>{text}</Box>
        <SentimentDissatisfiedIcon />
      </Box>
    );
  }

  const price = (calculatorInputs.pricing.value =
    calculatedCluster?.prices?.[0]?.total);

  return (
    <Box className="full-height flex-container direction-column">
      <Box className="pricing-panel-header">
        <h3>Your estimated on-demand monthly payment will be</h3>
      </Box>
      <Box>
        <Grid container className="justified-space-between">
          <Grid item className="roboto-font">
            <Box>On Demand</Box>
            <Box>
              <span className="price-text">${toLocalePrice(price)}</span>
              /mo
            </Box>
          </Grid>
          <Grid>
            <ContactUsBox />
          </Grid>
        </Grid>
      </Box>
      <Box className="compare-pricing-box">
        <Box>Compare Pricing</Box>
        <CompetitorSwitcher setMode={setMode} />
      </Box>
    </Box>
  );
}

CalculatorInstancePricing.propTypes = {
  calculatorInputs: PropTypes.shape({}),
  calculatedCluster: PropTypes.shape({
    prices: PropTypes.array,
    cluster: PropTypes.shape({}),
  }),
  internalParams: PropTypes.shape({}),
  classes: PropTypes.shape({}),
};

export default CalculatorInstancePricing;
